export default __webpack_public_path__ + "static/media/gallery-8-2.7c3a4f6a.webp";